import React from 'react';

import './styles.css';

const CalendarInterval = props => {
  const { data, actions } = props;
  const { TimeEnd, TimeStart, selected } = data;

  const onSelect = () => {
    actions.onSelectTime(data);
  };

  return (
    <div
      className={
        selected
          ? 'calendar-interval calendar-interval--selected'
          : 'calendar-interval'
      }
      onClick={onSelect}
    >
      <span className="calendar-interval__from">{TimeStart.label}</span>
      <span className="calendar-interval__till">{TimeEnd.label}</span>
    </div>
  );
};

export default CalendarInterval;
